<template>
    <div v-if="visible" class="cancel-modal-overlay" @click="handleOverlayClick">
        <div class="cancel-modal-content" @click.stop>
            <!-- 关闭按钮 -->
            <div class="close-button" @click="handleClose">
                <div class="close-circle"></div>
                <div class="close-icon">
                    <img src="../images/close-icon-1.svg" class="close-line" alt="" />
                    <img src="../images/close-icon-2.svg" class="close-line" alt="" />
                </div>
            </div>

            <!-- 弹窗主体 -->
            <div class="modal-body">
                <div class="modal-content">
                    <div class="modal-content-title">{{ nickname }}</div>
                    <div class="modal-content-session">{{ session }}</div>
                </div>

                <!-- 按钮组 -->
                <a class="button-group" @click="handleClose">
                    <!-- 确定按钮 -->
                    <a class="confirm-button">
                        <div class="confirm-button-text">開心收下</div>
                    </a>
                </a>
            </div>
        </div>
    </div>
</template>

<script >
import { defineEmits, defineProps } from 'vue-demi';
const __sfc_main = {};
__sfc_main.props = {
  visible: {
    type: Boolean,
    default: false
  },
  nickname: {
    type: String,
    default: ''
  },
  session: {
    type: String,
    default: ''
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const {
    useTeleport
  } = require('@fegobull/webapi').use;
  useTeleport(document.body);
  const props = __props;
  const emit = __ctx.emit;

  // 处理关闭
  const handleClose = () => {
    emit('close');
  };

  // 处理遮罩层点击
  const handleOverlayClick = () => {
    handleClose();
  };
  return {
    handleClose,
    handleOverlayClick
  };
};
export default __sfc_main;
</script>

<style scoped lang="less">
// 遮罩层
.cancel-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}

// 弹窗内容容器
// layout_9Y73JF
.cancel-modal-content {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.6rem;
    margin-top: -1.5rem;
}

// 关闭按钮
// layout_QYKJEI
.close-button {
    position: absolute;
    bottom: -0.9rem;
    left: 50%;
    transform: translateX(-50%);
    width: 0.5rem;
    height: 0.48rem;
    cursor: pointer;
    z-index: 10;

    // layout_UM99W8, fill_Y93CUQ, stroke_5VR16Q
    .close-circle {
        position: absolute;
        top: 0;
        left: 0;
        width: 0.5rem;
        height: 0.48rem;
        background: rgba(255, 255, 255, 0.15);
        border: 0.015rem solid #ffffff;
        border-radius: 50%;
    }

    // layout_7UFZEW
    .close-icon {
        position: absolute;
        left: 0.1875rem;
        top: 0.18rem;
        width: 0.125rem;
        height: 0.12rem;

        .close-line {
            position: absolute;
            top: 0;
            left: 0;
            width: 0.125rem;
            height: 0.12rem;
        }
    }
}

// 弹窗主体
// layout_A0UYIT, fill_0KUV7N
.modal-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    // gap: 0.1rem;
    // padding: 0.6rem 0.54rem;
    // height: 4.33rem;
    // background: #ffffff;
    // border-radius: 0.4rem;
}

.modal-content {
    position: relative;
    display: block;
    width: 7.5rem;
    height: 7rem;
    background-image: url('../images/success.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center center;
}

.modal-content-title {
    position: absolute;
    top: 4rem;
    left: 5.6rem;
    color: #1f1f1f;
    font-size: 0.22rem;
    font-weight: 500;
    transform: rotate(356deg);
    width: 1rem;
}
.modal-content-session {
    position: absolute;
    top: 3.3rem;
    left: 5.6rem;
    color: #1f1f1f;
    font-size: 0.22rem;
    font-weight: 500;
    transform: rotate(356deg);
}

// 标题
// layout_LOAIH2, style_XXPCCW, fill_C78OYA
.modal-title {
    width: 4.59rem;
    font-family: FZLanTingHei-M-GBK, sans-serif;
    font-weight: 400;
    font-size: 0.42rem;
    line-height: 1.5476em;
    text-align: center;
    color: #000000;
}

// 说明文字
// layout_AP26LR, style_J9W60E, fill_10N804
.modal-desc {
    width: 4.7rem;
    height: 1.34rem;
    font-family: FZLanTingHei-R-GBK, sans-serif;
    font-weight: 400;
    font-size: 0.28rem;
    line-height: 1.4286em;
    text-align: center;
    color: #7a7a7a;
    margin-top: 0.1rem;
}

// 按钮组
// layout_KF5X5G
.button-group {
    display: flex;
    flex-direction: row;
    gap: 0.1rem;
    width: 4.7rem;
    height: 0.88rem;
    margin-top: -0.5rem;
    z-index: 10;
}

// 确定按钮
// layout_59IZRO, stroke_YPOO29
.confirm-button {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 0.1rem;
    padding: 0.1rem 0.3rem;
    width: 5.5rem;
    height: 0.88rem;
    margin: 0 auto;
    background: #ff6900;
    border-radius: 0.44rem;
    cursor: pointer;
    transition: transform 0.2s ease;

    &:active {
        transform: scale(0.98);
    }

    // layout_7JSL3B, style_OFEMG1, fill_C78OYA
    .confirm-button-text {
        font-family: FZLanTingHei-M-GBK, sans-serif;
        font-weight: 400;
        font-size: 0.32rem;
        line-height: 0.625em;
        text-align: center;
        color: #ffffff;
    }
}

// 暂不按钮
// layout_59IZRO, fill_LANXD5
.cancel-button {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 0.1rem;
    padding: 0.1rem 0.3rem;
    width: 2.3rem;
    height: 0.88rem;
    background: #ff6900;
    border-radius: 0.44rem;
    cursor: pointer;
    transition: transform 0.2s ease;

    &:active {
        transform: scale(0.98);
    }

    // layout_7JSL3B, style_OFEMG1, fill_0KUV7N
    .cancel-button-text {
        font-family: FZLanTingHei-M-GBK, sans-serif;
        font-weight: 400;
        font-size: 0.32rem;
        line-height: 0.625em;
        text-align: center;
        color: #ffffff;
    }
}
</style>
